import Cookies from 'js-cookie'
import router from '../../router'
export default {
  namespaced: true,
  state: {
    token: Cookies.get('token') || '',
    userInfo: {},
    openVoice: 1,
    fromSaas: false // 是否从saas登录
  },                      
  getters: {},
  mutations: {
    SET_TOKEN (state, data) {
      state.token = data
    },
    CLEAR_INFO (state) {
      state.userInfo = {}
      state.token = ''
    },
    SET_USER_INFO (state, userInfo) {
      state.userInfo = userInfo
    },
    SET_OPEN_VOICE (state, boolean) {
      state.openVoice = boolean
    },
    SET_PROTOCOL (state, boolean) {
      state.userInfo.pageIndexProtocol.needRead = boolean
    },
    SET_ORIGIN (state, boolean) {
      state.fromSaas = boolean
    }
  },
  actions: {
    setTokenAndUserInfo ({ commit }, { token, auto, userInfo }) {
      let arr = ['token', token]
      if (auto) arr.push({ expires: 21 })
      Cookies.set(...arr)
      commit('SET_TOKEN', token)
      commit('SET_USER_INFO', userInfo)
    },
    clearInfo ({ commit }) {
      Cookies.remove('token')
      commit('CLEAR_INFO')
      const path = sessionStorage.getItem('loginPlatform') || '/login'
      router.replace({ path })
    },
    setUserInfo ({ commit }, userInfo) {
      commit('SET_USER_INFO', userInfo)
    },
    setOpenVoice ({ commit }, openVoice) {
      commit('SET_OPEN_VOICE', openVoice)
    },
    setProtocol ({commit}, userInfo) {
      commit('SET_PROTOCOL', userInfo)
    },
    setOrigin ({commit}, boolean) {
      commit('SET_ORIGIN', boolean)
    }
  }
}